import styled from 'styled-components'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import FieldTitle from './field-title'
import Dropdown from './caption-style-dropdown'

const Container = styled.div`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureCaptionStyleField = ({ field }: Props) => {
    return (
        <Container>
            <FieldTitle field={field} />
            <Dropdown />
        </Container>
    )
}

export default CreationCaptureCaptionStyleField
